import {FC, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  activateHubSpotIntegration,
  deactivateHubSpotIntegration,
  fetchActiveIntegrationApp,
  getActivateIntegrationByUser,
  getIntegrationRefetchDataStatus,
  resetSelectedIntegrationData,
} from '../IntegrationSlice/IntegrationSlice'
import {Form, Button, Accordion, Card, Row, Col} from 'react-bootstrap'
import {isLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {ExternalProvider} from '../IntegrationSlice/Types'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useLazyGetSendersQuery} from '../../../../../services/cellcast.v2'
import Select from 'react-select'
import {findIndex} from 'lodash'
import {
  useExportGhlContactMutation,
  useImportGhlContactMutation,
  useUpdateGhlSenderMutation,
  useUpdateEventTypeMutation,
  useUpdateWebhookMutation,
  useImportHubSpotContactMutation,
  useExportHubSpotContactMutation,
  useUpdateIntegrationAppDataMutation,
  useUpdateHubspotSenderMutation,
  useUpdatePhoneNumberFieldMutation,
} from '../../../../../services/cellcast'
import {SenderCamp} from '../../../../../services/cellcast.type'
import { REGION } from '../../../../Utils/Constant/ConstantForWebsite'

interface HubSpotProps {
  selectedExternalProvider: ExternalProvider
  userData: any
}

const HubSpot: FC<HubSpotProps> = ({selectedExternalProvider, userData}) => {
  let userId = ''
  if (userData && userData.user) {
    if (userData.user._id !== userData.user.ownerId && !userData.user.subClientAccountId) {
      userId = userData.user.ownerId
    } else {
      userId = userData.user._id
    }
  }

  const selectedActiveIntegration = useSelector(
    getActivateIntegrationByUser(userId, selectedExternalProvider._id)
  )

  const [isSubClient, setIsSubClient] = useState(false)
  const profileDetailState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const refetch = useSelector(getIntegrationRefetchDataStatus)
  const globalLoading = useSelector(isLoading)

  const dispatch = useDispatch()

  const [selectedSmsSender, setSelectedSmsSender] = useState('#SharedNum#')
  const [selectedMmsSender, setSelectedMmsSender] = useState('#SharedNum#')
  const [selectedPhonNumberField, setSelectedPhonNumberField] = useState('phone')
  const [accountId, setAccountId] = useState('')

  // load sender options
  const [fetchSender, {data, isFetching: fetchSenderIsFetching, isLoading: fetchSenderIsLoading}] =
    useLazyGetSendersQuery()
  const smsOptions = data?.data?.sms || [{value: '#SharedNum#', label: '#SharedNum#'}]
  const mmsOptions = data?.data?.mms || [{value: '#SharedNum#', label: '#SharedNum#'}]
  const API_URL = ENV().REACT_APP_API_URL

  const phoneNumberFieldOptions = [
    {value: 'phone', label: 'Phone'},
    {value: 'mobilephone', label: 'Mobile Phone'},
  ]

  const [updateSmsSender, {isLoading: updateSmsSenderLoading}] = useUpdateHubspotSenderMutation()
  const [updatePhoneNumberField, {isLoading: updatePhoneNumberFieldLoading}] = useUpdatePhoneNumberFieldMutation()

  const [importContact, {isLoading: importContactLoading}] = useImportHubSpotContactMutation()
  const [exportContact, {isLoading: exportContactLoading}] = useExportHubSpotContactMutation()

  const [value, setValue] = useState<{eventType: string; message: string}[]>([])
  const [eventTypeArr, setEventTypeArr] = useState([
    {value: 'contact_status_changed', label: 'Contacts - New or Status Changed'},
    {value: 'jobapplication_status_changed', label: 'Applications - New or Status Changed'},
    {value: 'job_status_changed', label: 'Job Orders - New or Status Changed'},
    {value: 'placement_status_changed', label: 'Placements - New or Status Changed'},
    {value: 'candidate_status_changed', label: 'Candidates - New or Status Changed'},
    {value: 'jobad_expired', label: 'Job Ad Expired'},
    {value: 'folder_job_added', label: 'Entity Added to Folder'},
    {value: 'jobad_posted', label: 'New Job Ad Posted'},
    {value: 'job_invoice_sent', label: 'New Retained Invoice Sent'},
    {value: 'company_status_changed', label: 'Companies - New or Status Changed'},
    {value: 'interview_scheduled', label: 'New Interview Scheduled'},
    {value: 'folder_job_removed', label: 'Entity Removed From Folder'},
  ])
  const [updateIntegrationData, {isLoading: updateIntegrationDataLoading}] =
    useUpdateIntegrationAppDataMutation()

  // load data when first load
  useEffect(() => {
    if (selectedExternalProvider._id) {
      dispatch(resetSelectedIntegrationData)
      dispatch(fetchActiveIntegrationApp())
      fetchSender(null)
    }
  }, [selectedExternalProvider])

  useEffect(() => {
    if (selectedActiveIntegration && selectedActiveIntegration.data) {
      console.log(selectedActiveIntegration, 'selectedActiveIntegration')
      if (selectedActiveIntegration.data?.hubspot?.smsSender) {
        setSelectedSmsSender(selectedActiveIntegration.data?.hubspot?.smsSender)
        setSelectedPhonNumberField(selectedActiveIntegration.data?.hubspot?.phoneNumberField)
      }
    }
  }, [selectedActiveIntegration])

  useEffect(() => {
    if (refetch) {
      dispatch(fetchActiveIntegrationApp())
    }
  }, [refetch])

  useEffect(() => {
    if (profileDetailState && profileDetailState.isSubClientAccount) {
      setIsSubClient(profileDetailState.isSubClientAccount)
    } else {
      setIsSubClient(false)
    }
  }, [profileDetailState])

  // handle delete
  const [isOpenDeactivateConfirmation, setIsOpenDeactivateConfirmation] = useState(false)
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false)

  const onClickDeactivateHandler = () => {
    setIsOpenDeactivateConfirmation(true)
  }

  const onClickActivateHandler = () => {
    // Configurable base URL and client ID

    const baseUrl = 'https://app.hubspot.com'
    const clientId = ENV().REACT_APP_HUBSPOT_CLIENT_ID
    const redirectUri = `${ENV().REACT_APP_FE_URL}/integration`
    const responseType = 'code'

    // Construct the OAuth URL dynamically
    const scope = [
      'crm.lists.read',
      'crm.lists.write',
      'crm.objects.appointments.read',
      'crm.objects.custom.read',
      'crm.objects.custom.write',
      'crm.objects.users.read',
      'actions',
      'automation',
      'crm.objects.contacts.read',
      'crm.objects.contacts.write',
      'conversations.read',
      'conversations.write',
      'tickets',
    ].join('%20')
    const oauthUrl = `${baseUrl}/oauth/authorize?redirect_uri=${redirectUri}&client_id=${clientId}&scope=${scope}`

    // Redirect the user to the OAuth provider's authorization screen
    const newWindow = window.open(oauthUrl, '_blank', 'width=800,height=600')

    const checkAuthCode = setInterval(() => {
      try {
        if (newWindow && newWindow.location && newWindow.location.search) {
          const urlParams = new URLSearchParams(newWindow.location.search)

          const code = urlParams.get('code')
          console.log('code', code)
          if (code) {
            dispatch(activateHubSpotIntegration({code})).then((res: any) => {
              if (res && res.payload && res.payload.error && res.payload.error.message) {
                toast.error(res.payload.error.message)
              } else {
                dispatch(fetchActiveIntegrationApp())
              }
            })
            clearInterval(checkAuthCode) // Stop the polling once we get the code
            newWindow.close() // Close the new tab after getting the code
          }
        }
      } catch (error) {}
    }, 1000)
  }

  const onUpdateSmsHandler = () => {
    updateSmsSender({
      sender: selectedSmsSender,
      type: SenderCamp.SMS,
      region: REGION.AU
    }).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        } else {
          toast.success(res?.data?.message)
          dispatch(fetchActiveIntegrationApp())
        }
      } else if ('error' in res) {
        toast.error(res.error)
      }
    })
  }

  const onUpdatePhoneNumberFieldHandler = () => {
    updatePhoneNumberField(selectedPhonNumberField).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        } else {
          toast.success(res?.data?.message)
          dispatch(fetchActiveIntegrationApp())
        }
      } else if ('error' in res) {
        toast.error(res.error)
      }
    })
  }


  const onImportContactHandler = () => {
    importContact(null).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        } else {
          toast.success(res?.data?.message)
        }
      } else if ('error' in res) {
        toast.error(res.error)
      }
    })
  }

  const onExportContactHandler = () => {
    exportContact(null).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        } else {
          toast.success(res?.data?.message)
        }
      } else if ('error' in res) {
        toast.error(res.error)
      }
    })
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenDeactivateConfirmation}
        handleClose={() => setIsOpenDeactivateConfirmation(false)}
        Message={'Are you sure, you want to deactivate integration ?'}
        confirm={() => setIsDeleteConfirm(true)}
        confirmBtnTitle='Yes, deactivate'
      />
    ),
    [isOpenDeactivateConfirmation]
  )

  useEffect(() => {
    if (isDeleteConfirm === true) {
      dispatch(deactivateHubSpotIntegration())
      setIsDeleteConfirm(false)
      setIsOpenDeactivateConfirmation(false)
    }
  }, [isDeleteConfirm])


  return (
    <div className='card p-7 pb-lg-4 p-lg-10'>
      {confirmation}
      <h1>Detail Integration</h1>
      <div className='row'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div
                className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'
                style={{
                  backgroundColor: '#f5f8fa',
                  borderColor: '#f5f8fa',
                  borderRadius: 5,
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderWidth: 1,
                }}
              >
                {selectedExternalProvider?.image == '' || selectedExternalProvider == undefined ? (
                  <span
                    className='squere1'
                    style={{
                      width: '100px',
                      height: '100px',
                    }}
                  >{`${
                    selectedExternalProvider?.name !== undefined &&
                    selectedExternalProvider?.name !== ''
                      ? selectedExternalProvider?.name.split('')?.[0]?.toUpperCase() ?? 'C'
                      : 'EP'
                  }`}</span>
                ) : (
                  <img src={selectedExternalProvider.image} alt='Hubspot' />
                )}
                <div
                  className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${
                    selectedActiveIntegration ? ' bg-success ' : 'bg-danger'
                  }`}
                ></div>
              </div>
            </div>
            <div className='flex-grow-1'>
              <span className='text-gray-800 fs-2 fw-bolder me-1 mb-10'>
                {selectedExternalProvider?.name ?? 'Undefined'}
              </span>
              <br />

              {selectedActiveIntegration ? (
                <div className='mt-5'>
                  <>
                    <Form.Group className='mb-5 mt-3'>
                      <Row>
                        <Col sm='6'>
                          <Form.Label>Import contacts from Hubspot</Form.Label>
                        </Col>
                        <Col sm='4'>
                          <Button
                            variant='info'
                            type='submit'
                            size='sm'
                            disabled={importContactLoading}
                            onClick={() => onImportContactHandler()}
                          >
                            {importContactLoading ? (
                              <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                            ) : (
                              'Import'
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group className='mb-5'>
                      <Row>
                        <Col sm='6'>
                          <Form.Label>Push contacts to Hubspot</Form.Label>
                        </Col>
                        <Col sm='4'>
                          <Button
                            variant='info'
                            type='submit'
                            size='sm'
                            disabled={exportContactLoading}
                            onClick={() => onExportContactHandler()}
                          >
                            {exportContactLoading ? (
                              <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                            ) : (
                              'Push Contacts'
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group className='mb-10'>
                      <Form.Label>Default SMS Sender</Form.Label>
                      <Row>
                        <Col sm='6'>
                          <Select
                            isSearchable={false}
                            isDisabled={fetchSenderIsFetching || fetchSenderIsLoading}
                            onChange={(e) => setSelectedSmsSender(e?.value || '')}
                            value={
                              smsOptions.find((el) => el.value === selectedSmsSender) ||
                              smsOptions[0]
                            }
                            options={[...smsOptions]}
                            name='message'
                            className={`common-select `}
                            placeholder='Custom-LandingPage'
                          />
                        </Col>
                        <Col sm='4'>
                          <Button
                            variant='info'
                            type='submit'
                            size='sm'
                            disabled={updateSmsSenderLoading}
                            onClick={() => onUpdateSmsHandler()}
                          >
                            {updateSmsSenderLoading ? (
                              <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                            ) : (
                              'Configure'
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </Form.Group>

                  <Form.Group className='mb-10'>
                      <Form.Label>Default Phone Number Field</Form.Label>
                      <Row>
                        <Col sm='6'>
                          <Select
                            isSearchable={false}
                            onChange={(e) => setSelectedPhonNumberField(e?.value || '')}
                            value={
                              phoneNumberFieldOptions.find((el) => el.value === selectedPhonNumberField)
                            }
                            options={phoneNumberFieldOptions}
                            name='message'
                            className={`common-select`}
                            placeholder='Select Phone Number Field'
                          />
                        </Col>
                        <Col sm='4'>
                          <Button
                            variant='info'
                            type='submit'
                            size='sm'
                            disabled={updatePhoneNumberFieldLoading}
                            onClick={() => onUpdatePhoneNumberFieldHandler()}
                          >
                            {updatePhoneNumberFieldLoading ? (
                              <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                            ) : (
                              'Configure'
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </Form.Group>
                  </>

                  <Button
                    variant='danger'
                    type='submit'
                    disabled={globalLoading}
                    onClick={() => onClickDeactivateHandler()}
                  >
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Deactivate'
                    )}
                  </Button>
                </div>
              ) : (
                <div className='mt-20'>
                  <Button variant='primary' type='button' onClick={() => onClickActivateHandler()}>
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Activate'
                    )}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {HubSpot}
